var _polyline, _line, _polyline2, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgResetPayline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#C9C9C9",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "feather feather-shuffle align-middle me-2"
}, props), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
  points: "16 3 21 3 21 8"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 4,
  y1: 20,
  x2: 21,
  y2: 3
})), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
  points: "21 16 21 21 16 21"
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 15,
  y1: 15,
  x2: 21,
  y2: 21
})), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
  x1: 4,
  y1: 4,
  x2: 9,
  y2: 9
})));
export default SvgResetPayline;